export default {
	TABLE_TITLE: 'Ingredients',
	NUTRITION_VALUES: 'Nutrition values',
	ALLERGENS: 'Allergens',
	ALTERNATIVES: 'Alternatives',
};
